// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.my-font{
    font-family: "Cairo", sans-serif;
    font-optical-sizing: auto;
    font-weight: 400;
    font-style: normal;
    font-variation-settings:
        "slnt" 0;
    }
    
    
    
    @media(max-width:600px){
        .sub-main{
            margin-right: 13px !important; ;
            margin-left: 9px !important;
        }
    }
    
    /* Start List Post */
    .all-post-page{
    padding-top: 30px;
    height: calc(100vh - 77px);
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    padding-bottom: 80px;
    }

    .all-post-page .list-posts-tools{
        display: flex;
        align-items: center;
    }
    .all-post-page .list-posts-tools .non-zero{
        margin: 0px 10px;
    }

    .all-post-page .list-posts-tools .non-zero p{
        font-weight: 700;

    }
    .all-post-page .list-posts-tools .non-zero{
        display: flex;
        align-items: center;
    }

    .all-post-page .list-posts-tools .non-zero .non-slider{
        background-color: white;
        border: 2px solid #EEE;
        padding: 4px 6px;
        width: 45px;
        cursor: pointer;
        height: 23px;
        border-radius: 22px;
        margin: 0px 8px;
        position: relative;
    }

    .all-post-page .list-posts-tools .non-zero .non-slider .ball-slide{
        background-color: #d9d8d8;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        position: absolute;
        left: 3px;
        top: 50%;
        transform: translateY(-50%);
        transition: var(--main-transition);
    }

    .all-post-page .list-posts-tools .non-zero .non-slider .ball-active{
        background-color: #28a745;
        left: 22px;
    }

    ::-webkit-scrollbar {
    width: 0px;
    }
    
    .all-post-page .post-com{
    width: 600px;
    max-width: 100%;
    background-color: white;
    border-radius: 6px;
    padding: 10px 8px;
    margin-bottom:20px ;
    }

    @media(max-width:600px){
        .all-post-page .post-com{
            max-width: 96%;
        }
    }
    
    .all-post-page .post-com .post-head{
        display: flex;
        align-items: center;
        justify-content: space-between;
    
    }
    
    .all-post-page .post-com .post-head .titles{
        display: flex;
    }
    
    .all-post-page .select-all-btn {
        width: 150px;
        margin: 12px 0px;
        cursor: pointer;
        font-weight: 600;
        color: white;
        background-color: var(--main-color);
        border-radius: 22px;
        border: none;
        transition: var(--main-transition);
        padding: 8px 2px;
    }
    
    .all-post-page .select-all-btn:hover{
        opacity: .8;
    }
    
    .all-post-page .post-com .post-head .add-btn button {
        background-color: transparent;
        cursor: pointer;
        border: none;
    }
    
    .all-post-page .post-com .post-head .add-btn button svg{
        font-size: 20px;
        margin: 0 5px;
        color: var(--gray-color);
        transition: var(--main-transition);
    }
    
    .all-post-page .post-com .post-head .add-btn button .active{
        color: black;
    }
    
    .all-post-page .post-com .post-head .image img{
        width: 40px;
        height: 40px;
        border-radius: 50%;
    }
    
    .all-post-page .post-com .post-head .info{
        display: flex;
        flex-direction: column;
        margin:0px 8px;
        
    }
    
    .all-post-page .post-com .post-head .info h3 ,
    .all-post-page .post-com .post-head .info p {
        padding: 0;
        margin: 0;
    }
    .all-post-page .post-com .post-head .info h3{
        font-size: 16px;
    
    }
    
    .all-post-page .post-com .post-head .info .date{
        color: var(--gray-color);
        font-size: 13px;
        margin-top: -6px;
    }
    
    .all-post-page .post-com .post-body{
        width: 100%;
        
        
    }
    
    .all-post-page .post-com .post-comment{
        padding: 0px 5px;
        margin: 10px 0px;
    }
    
    .all-post-page .post-com .post-comment .comment-btn{
        background-color: var(--main-color);
        width: 100%;
        font-weight: bold;
        padding: 10px 0px;
        border-radius: 7px;
        border: none;
        color: white;
        cursor: pointer;
    }
    
    .all-post-page .post-com .post-image{
    margin: 10px 0px;
    }
    
    .all-post-page .post-com .post-image img {
        width: 100%;
        max-width: 100%;
        object-fit:contain;
        height: 400px;
        border-radius: 5px;
    }

    
    .all-post-page .post-com .copied  svg{
        color: #28a745 !important;
    }
    
    
    
    .all-post-page .main-pagination{
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 650px;
    }
    
    .all-post-page .main-pagination .pagination-btn{
        width: 100px;
        margin: 10px 0px;
    }
    
    .all-post-page .main-pagination .pagination-btn button{
        color: white;
        background-color: var(--main-color); 
        border-radius: 22px;
        cursor: pointer;
        padding: 10px 22px;
        border: none;
        cursor: pointer;
    }
    
    .search-barf{
        width: 600px;
        max-width: 100%;
        margin-bottom: 10px;
        /* border: 1px solid #EEE; */
        border-radius: 6px;
        padding: 10px 10px;
        display: flex;
        background-color: white;
        align-items: center;
    }

    @media(max-width:600px){
        .search-barf{
            max-width: 95%;
        }
    }
    
    .search-barf input{
        border: none;
        background-color: transparent;
        width: calc(100% - 18px);
    }
    
    .search-bar input::placeholder{
        color: var(--gray-color);
    }
    
    .search-barf input:focus{
        outline: none;
    }
    
    .search-barf svg{
        color: var(--gray-color);
        margin:0px 6px;
        width: 18px;
    }
    
    .all-post-page .search-btn {
        background-color: var(--main-color);
        border: none;
        width: 120px;
        border-radius: 22px;
        margin-left: -28px;
        color: white;
        cursor: pointer;
        font-weight: bold;
        height: 36px;
        transition: var(--main-transition);
    }
    
    .all-post-page .search-btn:hover{
        background-color: #0876f5;
    }

    
    
    /* End Post Component */


    /* Start Button Hover */

    .btn-hover{
        transition: var(--main-transition);
    }

    .btn-hover:hover{
        opacity: .8;
    }

    /* End Button Hover */`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;IAClB;gBACY;IACZ;;;;IAIA;QACI;YACI,6BAA6B;YAC7B,2BAA2B;QAC/B;IACJ;;IAEA,oBAAoB;IACpB;IACA,iBAAiB;IACjB,0BAA0B;IAC1B,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB;;IAEA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;;IAEpB;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,uBAAuB;QACvB,sBAAsB;QACtB,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,YAAY;QACZ,mBAAmB;QACnB,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;QACzB,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,SAAS;QACT,QAAQ;QACR,2BAA2B;QAC3B,kCAAkC;IACtC;;IAEA;QACI,yBAAyB;QACzB,UAAU;IACd;;IAEA;IACA,UAAU;IACV;;IAEA;IACA,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB;;IAEA;QACI;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;;IAElC;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;QACZ,gBAAgB;QAChB,eAAe;QACf,gBAAgB;QAChB,YAAY;QACZ,mCAAmC;QACnC,mBAAmB;QACnB,YAAY;QACZ,kCAAkC;QAClC,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,6BAA6B;QAC7B,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,wBAAwB;QACxB,kCAAkC;IACtC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,cAAc;;IAElB;;IAEA;;QAEI,UAAU;QACV,SAAS;IACb;IACA;QACI,eAAe;;IAEnB;;IAEA;QACI,wBAAwB;QACxB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;;;IAGf;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,mCAAmC;QACnC,WAAW;QACX,iBAAiB;QACjB,iBAAiB;QACjB,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;;IAEA;IACA,gBAAgB;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,kBAAkB;QAClB,aAAa;QACb,kBAAkB;IACtB;;;IAGA;QACI,yBAAyB;IAC7B;;;;IAIA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;QAC9B,YAAY;IAChB;;IAEA;QACI,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,mCAAmC;QACnC,mBAAmB;QACnB,eAAe;QACf,kBAAkB;QAClB,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,eAAe;QACf,mBAAmB;QACnB,4BAA4B;QAC5B,kBAAkB;QAClB,kBAAkB;QAClB,aAAa;QACb,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI;YACI,cAAc;QAClB;IACJ;;IAEA;QACI,YAAY;QACZ,6BAA6B;QAC7B,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,wBAAwB;QACxB,cAAc;QACd,WAAW;IACf;;IAEA;QACI,mCAAmC;QACnC,YAAY;QACZ,YAAY;QACZ,mBAAmB;QACnB,kBAAkB;QAClB,YAAY;QACZ,eAAe;QACf,iBAAiB;QACjB,YAAY;QACZ,kCAAkC;IACtC;;IAEA;QACI,yBAAyB;IAC7B;;;;IAIA,uBAAuB;;;IAGvB,uBAAuB;;IAEvB;QACI,kCAAkC;IACtC;;IAEA;QACI,WAAW;IACf;;IAEA,qBAAqB","sourcesContent":[".my-font{\n    font-family: \"Cairo\", sans-serif;\n    font-optical-sizing: auto;\n    font-weight: 400;\n    font-style: normal;\n    font-variation-settings:\n        \"slnt\" 0;\n    }\n    \n    \n    \n    @media(max-width:600px){\n        .sub-main{\n            margin-right: 13px !important; ;\n            margin-left: 9px !important;\n        }\n    }\n    \n    /* Start List Post */\n    .all-post-page{\n    padding-top: 30px;\n    height: calc(100vh - 77px);\n    overflow-y: scroll;\n    display: flex;\n    flex-direction: column;\n    padding-bottom: 80px;\n    }\n\n    .all-post-page .list-posts-tools{\n        display: flex;\n        align-items: center;\n    }\n    .all-post-page .list-posts-tools .non-zero{\n        margin: 0px 10px;\n    }\n\n    .all-post-page .list-posts-tools .non-zero p{\n        font-weight: 700;\n\n    }\n    .all-post-page .list-posts-tools .non-zero{\n        display: flex;\n        align-items: center;\n    }\n\n    .all-post-page .list-posts-tools .non-zero .non-slider{\n        background-color: white;\n        border: 2px solid #EEE;\n        padding: 4px 6px;\n        width: 45px;\n        cursor: pointer;\n        height: 23px;\n        border-radius: 22px;\n        margin: 0px 8px;\n        position: relative;\n    }\n\n    .all-post-page .list-posts-tools .non-zero .non-slider .ball-slide{\n        background-color: #d9d8d8;\n        border-radius: 50%;\n        width: 15px;\n        height: 15px;\n        position: absolute;\n        left: 3px;\n        top: 50%;\n        transform: translateY(-50%);\n        transition: var(--main-transition);\n    }\n\n    .all-post-page .list-posts-tools .non-zero .non-slider .ball-active{\n        background-color: #28a745;\n        left: 22px;\n    }\n\n    ::-webkit-scrollbar {\n    width: 0px;\n    }\n    \n    .all-post-page .post-com{\n    width: 600px;\n    max-width: 100%;\n    background-color: white;\n    border-radius: 6px;\n    padding: 10px 8px;\n    margin-bottom:20px ;\n    }\n\n    @media(max-width:600px){\n        .all-post-page .post-com{\n            max-width: 96%;\n        }\n    }\n    \n    .all-post-page .post-com .post-head{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n    \n    }\n    \n    .all-post-page .post-com .post-head .titles{\n        display: flex;\n    }\n    \n    .all-post-page .select-all-btn {\n        width: 150px;\n        margin: 12px 0px;\n        cursor: pointer;\n        font-weight: 600;\n        color: white;\n        background-color: var(--main-color);\n        border-radius: 22px;\n        border: none;\n        transition: var(--main-transition);\n        padding: 8px 2px;\n    }\n    \n    .all-post-page .select-all-btn:hover{\n        opacity: .8;\n    }\n    \n    .all-post-page .post-com .post-head .add-btn button {\n        background-color: transparent;\n        cursor: pointer;\n        border: none;\n    }\n    \n    .all-post-page .post-com .post-head .add-btn button svg{\n        font-size: 20px;\n        margin: 0 5px;\n        color: var(--gray-color);\n        transition: var(--main-transition);\n    }\n    \n    .all-post-page .post-com .post-head .add-btn button .active{\n        color: black;\n    }\n    \n    .all-post-page .post-com .post-head .image img{\n        width: 40px;\n        height: 40px;\n        border-radius: 50%;\n    }\n    \n    .all-post-page .post-com .post-head .info{\n        display: flex;\n        flex-direction: column;\n        margin:0px 8px;\n        \n    }\n    \n    .all-post-page .post-com .post-head .info h3 ,\n    .all-post-page .post-com .post-head .info p {\n        padding: 0;\n        margin: 0;\n    }\n    .all-post-page .post-com .post-head .info h3{\n        font-size: 16px;\n    \n    }\n    \n    .all-post-page .post-com .post-head .info .date{\n        color: var(--gray-color);\n        font-size: 13px;\n        margin-top: -6px;\n    }\n    \n    .all-post-page .post-com .post-body{\n        width: 100%;\n        \n        \n    }\n    \n    .all-post-page .post-com .post-comment{\n        padding: 0px 5px;\n        margin: 10px 0px;\n    }\n    \n    .all-post-page .post-com .post-comment .comment-btn{\n        background-color: var(--main-color);\n        width: 100%;\n        font-weight: bold;\n        padding: 10px 0px;\n        border-radius: 7px;\n        border: none;\n        color: white;\n        cursor: pointer;\n    }\n    \n    .all-post-page .post-com .post-image{\n    margin: 10px 0px;\n    }\n    \n    .all-post-page .post-com .post-image img {\n        width: 100%;\n        max-width: 100%;\n        object-fit:contain;\n        height: 400px;\n        border-radius: 5px;\n    }\n\n    \n    .all-post-page .post-com .copied  svg{\n        color: #28a745 !important;\n    }\n    \n    \n    \n    .all-post-page .main-pagination{\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        width: 650px;\n    }\n    \n    .all-post-page .main-pagination .pagination-btn{\n        width: 100px;\n        margin: 10px 0px;\n    }\n    \n    .all-post-page .main-pagination .pagination-btn button{\n        color: white;\n        background-color: var(--main-color); \n        border-radius: 22px;\n        cursor: pointer;\n        padding: 10px 22px;\n        border: none;\n        cursor: pointer;\n    }\n    \n    .search-barf{\n        width: 600px;\n        max-width: 100%;\n        margin-bottom: 10px;\n        /* border: 1px solid #EEE; */\n        border-radius: 6px;\n        padding: 10px 10px;\n        display: flex;\n        background-color: white;\n        align-items: center;\n    }\n\n    @media(max-width:600px){\n        .search-barf{\n            max-width: 95%;\n        }\n    }\n    \n    .search-barf input{\n        border: none;\n        background-color: transparent;\n        width: calc(100% - 18px);\n    }\n    \n    .search-bar input::placeholder{\n        color: var(--gray-color);\n    }\n    \n    .search-barf input:focus{\n        outline: none;\n    }\n    \n    .search-barf svg{\n        color: var(--gray-color);\n        margin:0px 6px;\n        width: 18px;\n    }\n    \n    .all-post-page .search-btn {\n        background-color: var(--main-color);\n        border: none;\n        width: 120px;\n        border-radius: 22px;\n        margin-left: -28px;\n        color: white;\n        cursor: pointer;\n        font-weight: bold;\n        height: 36px;\n        transition: var(--main-transition);\n    }\n    \n    .all-post-page .search-btn:hover{\n        background-color: #0876f5;\n    }\n\n    \n    \n    /* End Post Component */\n\n\n    /* Start Button Hover */\n\n    .btn-hover{\n        transition: var(--main-transition);\n    }\n\n    .btn-hover:hover{\n        opacity: .8;\n    }\n\n    /* End Button Hover */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
